import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useFlandersFeature } from "../../../hooks/mapHooks";
import { Attribute, Layer, MapPositionBounds } from "../../../types";
import { LayerProperties } from "./LayerProperties";

interface Props {
  skipKey?: string;
  layer: Layer;
  groupingKey: string | undefined;
  groupingCount: number | undefined;
  attributes: Attribute[];
  mapPosition: MapPositionBounds;
}

export function LayerPropertiesFlandersFeature(props: Props) {
  const {
    skipKey,
    attributes,
    layer,
    groupingKey,
    groupingCount,
    mapPosition,
  } = props;
  const { data: feature } = useFlandersFeature(
    layer,
    mapPosition,
    skipKey,
    groupingKey,
    groupingCount && groupingCount > 1 ? groupingCount : 50
  );
  const attributeLayersKeys = attributes.reduce(
    (keys: string[], attribute: Attribute) => {
      if (
        attribute.layers &&
        attribute.layers !== skipKey &&
        !keys.includes(attribute.layers)
      )
        return [...keys, attribute.layers];
      return [...keys];
    },
    []
  );
  const ownAttributes = attributes.filter(
    (attr) => (!skipKey && !attr.layers) || attr.layers === skipKey
  );

  return (
    <>
      <ErrorBoundary fallbackRender={(props) => null}>
        <Suspense fallback={null}>
          <LayerProperties
            feature={feature}
            groupingKey={groupingKey}
            attributes={ownAttributes}
          />
        </Suspense>
      </ErrorBoundary>
      {attributeLayersKeys.map((atrributeKey) => (
        <ErrorBoundary
          key={`point-feature-${atrributeKey}`}
          fallbackRender={(props) => null}
        >
          <Suspense fallback={null}>
            <LayerPropertiesFlandersFeature
              skipKey={atrributeKey}
              layer={layer}
              groupingKey={groupingKey}
              groupingCount={groupingCount}
              mapPosition={mapPosition}
              attributes={attributes.filter(
                (attr) => attr.layers === atrributeKey
              )}
            />
          </Suspense>
        </ErrorBoundary>
      ))}
    </>
  );
}
